<template>
  <div class="modal" v-bind:class="{ 'is-active': isActive }">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ modalTitle }}</p>
        <button class="delete" aria-label="close" v-on:click="$emit('close-modal')"></button>
      </header>
      <section class="modal-card-body">
        <div class="content">
          <p>{{ modalBody }}</p>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button class="button is-success" v-on:click="$emit('close-modal')">OK</button>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    modalTitle: {
      type: String,
      default: '',
    },
    modalBody: {
      type: String,
      default: '',
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">

</style>
